import React from "react";
import { connect } from "react-redux";
import "./index.scss";
import * as Analytics from "../../redux/actions/analytics";
import * as CONSTANTS from "../../functions/constants";
import SidePanel, { SidePanelHeader, SidePanelContent } from "../SidePanel";
import Btn from "../Btn";
import { LOADING_STATUS } from "../LoadBlocker";

const mapStateToProps = (state) => {
    return {
        bearerToken: state.CurrentUser.bearerToken,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        __ga4TrackEvent: (eventName, additionalInfo) => dispatch(Analytics.__ga4TrackEvent(eventName, additionalInfo)),
        __trackEvent: (eventType, pageType, category, subCategory, additionalInfo) => dispatch(Analytics.__trackEvent(eventType, pageType, category, subCategory, additionalInfo)),
    };
};

const ConnectedSidePanelLoginC4B = ({ bearerToken, __ga4TrackEvent, __trackEvent }) => {
    const loadStatus = LOADING_STATUS.init;

    const handleBtnContinueClick = () => {
        window.location.href = "https://www.coles.com.au";
    };

    return (
        <SidePanel panelMode={CONSTANTS.SIDEPANEL_MODE.LoginC4B}>
            <SidePanelHeader title="Coles for Business Login" dialogTitleId={CONSTANTS.SIDEPANEL_MODE.LoginC4B}></SidePanelHeader>
            <SidePanelContent>
                <div className={`grid-container shaded-panel loader-container ${loadStatus} ${!bearerToken ? "loading" : ""}`}>
                    <div className="grid-x">
                        <div className="cell small-12">
                            <p className="create-acc-cta">You can no longer log in to Liquor Connection.</p>
                            <p className="create-acc-cta">
                                To continue to shop for your business click Continue and we’ll redirect you to{" "}
                                <a href="https://www.coles.com.au/" className="redirect-link">
                                    Coles for Business
                                </a>
                                . For personal shopping, you can visit{" "}
                                <a href="https://www.liquorland.com.au/" className="redirect-link">
                                    Liquorland
                                </a>
                                .
                            </p>
                        </div>
                        <div className="cell small-12">
                            <Btn label="Continue" icon="" large className="btn-submit" disabled={loadStatus === LOADING_STATUS.loading || !bearerToken} onClick={handleBtnContinueClick} />
                        </div>
                    </div>
                </div>
            </SidePanelContent>
        </SidePanel>
    );
};

const SidePanelLoginC4B = connect(mapStateToProps, mapDispatchToProps)(ConnectedSidePanelLoginC4B);
export default SidePanelLoginC4B;
